module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_3-85bb49de7e4a197bae5c367883b2a229.webp";